import * as React from 'react';

export const VkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#A84DFF"
      d="M17.5 13.436v-4.62c0-1.04-.189-1.25-1.226-1.25L13.338 7.5c-.914 0-1.372 0-1.556.297-.185.296.02.701.428 1.512.227.45.349.777.349 1.281v3.324c0 1.052 0 1.577-.4 1.733-.4.156-.731-.197-1.395-.902-1.627-1.73-2.474-3.89-3.03-6.243-.116-.488-.173-.731-.345-.867C7.215 7.5 6.97 7.5 6.48 7.5H3.731c-.603 0-.905 0-1.093.213-.188.214-.152.486-.079 1.03.66 4.908 4.976 12.956 12.95 13.724 1.413.136 1.991-.246 1.991-1.793 0-.877-.019-2.295 1.085-2.481.578-.098.968.108 1.614.65 1.12.94 1.707 2.086 2.116 2.958.27.578.472.699 1.11.699h2.592c1.31 0 1.667-.32 1.084-1.55a11.206 11.206 0 0 0-2.746-3.616c-.794-.684-1.191-1.026-1.214-1.278-.022-.251.27-.608.852-1.32 1.126-1.377 2.657-3.539 3.372-5.832.355-1.137.021-1.404-1.13-1.404h-2.329c-1.128 0-1.127-.039-1.394 1.241-.432 2.077-1.847 4.073-3.177 5.432-.63.644-1.012 1.033-1.406.874-.394-.158-.429-.642-.429-1.611Z"
    />
  </svg>
);
